import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';


var config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};
class Firebase {
  constructor() {
    app.initializeApp(config);
    
    this.fieldValue = app.firestore.FieldValue;
    this.auth = app.auth();
    this.db = app.firestore();
  }

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);


  onAuthUserListener = (next, fallback) =>
    this.auth.onAuthStateChanged(authUser => {
      if (authUser) {
        this.user(authUser.uid)
          .get()
          .then(snapshot => {
            const dbUser = snapshot.data();
            // default empty roles
            if (!dbUser.roles) {
              dbUser.roles = {};
            }
            // merge auth and db user
            authUser = {
              uid: authUser.uid,
              email: authUser.email,
              emailVerified: authUser.emailVerified,
              providerData: authUser.providerData,
              ...dbUser,
            };
            next(authUser);
          });
      } else {
        fallback();
      }
    });
  
   
   // *** User API ***
 
  users = () => this.db.collection('users');
  aggUsers = (uid) => this.db.doc(`aggregation/${uid}`);
  optimized = (uid) => this.db.doc(`optimized/${uid}`);
  registered = () => this.db.collection('registered');
  ncdctotal = uid => this.db.doc(`ncdcTotal/${uid}`);
 
}
export default Firebase;